import { Swiper, EffectFade, Pagination } from 'swiper'

Swiper.use([EffectFade, Pagination])

const fn = {
  init: () => {
    document.querySelectorAll('.featured-items-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const textSliderContainer = el.querySelector('.featured-items-text-slider .swiper-container')
    const bgSliderContainer = el.querySelector('.featured-items-bg-slider .swiper-container')

    const textSwiper = new Swiper(textSliderContainer, {
      autoHeight: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        768: {
          autoHeight: false,
        },
      },
    })

    const bgSliderOpts = {
      slidesPerView: 1,
      speed: 500,
      autoplay: {
        delay: 6000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      on: {
        slideChangeTransitionStart: (swiper) => {
          textSwiper.slideTo(swiper.activeIndex)
        },
      },
    }

    new Swiper(bgSliderContainer, bgSliderOpts)
  },
}

export default {
  can: () => true,
  run: fn.init,
}
